import { ReactElement } from "react";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import ElectricMeterRoundedIcon from "@mui/icons-material/ElectricMeterRounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import PriceCheckRoundedIcon from "@mui/icons-material/PriceCheckRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import WebRoundedIcon from "@mui/icons-material/WebRounded";

import { dic } from "@common/text_defs";
import ProductDetailPage from "./components/ProductDetailPage";

const WorkCustomerManagementPage = (): ReactElement => (
  <ProductDetailPage
    eyebrow="CUSTOMER & BILLING PLATFORM"
    title={dic.works.prod_OEMS.title}
    description={dic.works.prod_OEMS.desc}
    summaryTitle="顧客ライフサイクルを一元管理"
    summaryDescription="見込み顧客の登録から契約、使用量管理、料金計算、請求・回収までを一つのシステムで管理。小売電気事業者様と需要家様、双方の業務を支えます。"
    flowTitle="契約から回収までを一つの流れに"
    flow={[
      { label: "顧客登録", detail: "見込み・契約情報", icon: PersonAddAltRoundedIcon },
      { label: "使用量管理", detail: "検針・実績データ", icon: ElectricMeterRoundedIcon },
      { label: "料金計算", detail: "料金メニュー・割引", icon: PriceCheckRoundedIcon },
      { label: "請求・回収", detail: "請求書・入金状況", icon: AccountBalanceWalletRoundedIcon },
    ]}
    capabilities={[
      { title: "顧客・契約管理", description: "見込み顧客から契約中・解約済みまで、顧客情報と契約状況をまとめて管理します。", icon: BadgeRoundedIcon },
      { title: "使用量管理", description: "需要家ごとの電力使用量を取り込み、期間別の実績確認や料金計算に活用します。", icon: ElectricMeterRoundedIcon },
      { title: "料金計算", description: "多様な料金メニューや割引条件に対応し、契約内容に沿った電気料金を算定します。", icon: PriceCheckRoundedIcon },
      { title: "請求書発行", description: "計算結果から請求データと請求書を作成し、毎月の請求業務を効率化します。", icon: ReceiptLongRoundedIcon },
      { title: "入金・回収管理", description: "入金状況と未収金を把握し、請求後の確認や回収業務を支援します。", icon: DescriptionRoundedIcon },
      { title: "ポータル・レポート", description: "需要家向けの使用量・料金照会と、事業者向けの集計・レポートを提供します。", icon: WebRoundedIcon },
    ]}
    valuesTitle="正確な請求と、迅速な顧客対応へ"
    valuesDescription="顧客・契約・使用量・料金を同じ基盤で扱うことで、部門をまたぐ確認作業を減らし、日々の運用品質を高めます。"
    values={[
      { title: "情報を一元化", description: "顧客、契約、使用量、請求履歴を横断して確認" },
      { title: "複雑な料金に対応", description: "契約ごとの料金条件を反映し、計算業務を標準化" },
      { title: "セルフサービスを支援", description: "需要家自身が使用量や料金をいつでも確認" },
    ]}
    contactTitle="顧客管理・請求業務に合わせてご提案します"
    colors={{ dark: "#173f57", darkAlt: "#206b76", primary: "#9fe0dc", pale: "#e6f2f2", accent: "#f4c86a", text: "#173541" }}
  />
);

export default WorkCustomerManagementPage;
